import { adminApi } from '@/api/endpoints';
import type { FeedbackMessage } from '@/api/types';
import { Alert, Card, Spinner } from '@/components/ui';
import { formatDateTime } from '@/lib/datetime';
import { useAsync } from '@/lib/useAsync';
import styles from './admin.module.css';

/**
 * Feedback-Übersicht (Migration 018) — Sicherheitsnetz zur Mail, die auf dem
 * Shared-Host nicht garantiert zugestellt wird. Absendername fehlt bei
 * anonymen Nachrichten auch hier (weich-anonym, Backend blendet ihn schon aus).
 */
export function AdminFeedbackPage() {
  const { data: messages, loading, error } = useAsync<FeedbackMessage[]>(
    (signal) => adminApi.listFeedback(signal),
    [],
  );

  if (loading) return <Spinner label="Feedback wird geladen…" />;
  if (error) return <Alert>{error}</Alert>;

  const list = messages ?? [];

  return (
    <>
      <Card>
        <h2>Feedback</h2>
        <p className="muted">
          Nachrichten von Mitgliedern, neueste zuerst. Wird zusätzlich per Mail verschickt — diese
          Liste ist das Sicherheitsnetz, falls eine Mail nicht ankommt.
        </p>
      </Card>

      {list.length === 0 && (
        <Card>
          <p className="muted">Noch kein Feedback eingegangen.</p>
        </Card>
      )}

      {list.map((m) => (
        <Card key={m.id}>
          <div className={styles.row}>
            <div className={styles.rowMain}>
              <div className={styles.rowTitle}>
                {m.is_anonymous ? 'Anonym' : (m.display_name ?? 'Unbekannt')}
              </div>
              <div className="muted" style={{ fontSize: '0.85rem' }}>
                {formatDateTime(m.created_at)}
                {!m.mailed_at && ' · Mail nicht bestätigt'}
              </div>
            </div>
          </div>
          <p style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>{m.message}</p>
        </Card>
      ))}
    </>
  );
}
